import { Flex, Grid, Space } from '@mantine/core';
import { FC, Fragment, useEffect, useState } from 'react';
import { WidgetHeader } from 'src/components';
import { useToggleCheckbox } from 'src/hooks/useToggleCheckbox';
import { LeftSectionWidget } from 'src/components';
import { WidgetPreview } from 'src/components';
import { fetchWidget, setDefaultWidgetState, useAppDispatch, useAppSelector } from 'src/store';
import { useParams } from 'react-router-dom';
import { shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle, useMediaQuery } from '@mantine/hooks';
import { BottomActions } from 'src/components/LeftSectionWidget/components';
import { getWidgetInstructionStatus } from 'src/helpers/localStorageHelper';

const WidgetPage: FC = () => {
  const [t] = useTranslation('widget');
  const [icon, setIcon] = useState<string>('variant-1');
  const { state, handleCheckboxChange, handleGroupCheckboxChange, checkedIds } = useToggleCheckbox();
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const user = useAppSelector((state) => state.user, shallowEqual);
  const widget = useAppSelector((state) => state.widget, shallowEqual);
  const isMediumDevice = useMediaQuery('(max-width: 992px)');
  const [isWidgetPreview, setIsWidgetPreview] = useState(false);
  const [showWidgetInstruction, setShowWidgetInstruction] = useState(
    'true' === getWidgetInstructionStatus() ? false : true,
  );
  const [widgetState, setWidgetState] = useState({ ...widget.data });

  useDocumentTitle(t('widgetPageTitle'));

  useEffect(() => {
    if (user.data.userId && id) {
      dispatch(fetchWidget({ siteId: id }));
    }

    return () => {
      dispatch(setDefaultWidgetState());
    };
  }, [dispatch, id, user.data.userId]);

  const [hideIaLabsLogo, setHideIaLabsLogo] = useState(false);
  const [colorDisplay, setColorDisplay] = useState<{ lightMode: string | null; darkmode: string | null }>({
    lightMode: null,
    darkmode: null,
  });

  useEffect(() => {
    if (widget.data) {
      setHideIaLabsLogo(widget.data.hideIaLabsLogo);
      setColorDisplay(widget.data.colors);
    }
  }, [widget]);

  return (
    <Fragment>
      <Grid bg={'#F6FAFA'} m={0} pb={24}>
        <Flex direction="column" w="100%">
          <Flex direction="column">
            <WidgetHeader />
            <Space h={24} />
            <Flex justify="space-between">
              {(!isWidgetPreview || !isMediumDevice) && (
                <Flex direction="column" w={!isMediumDevice ? '63%' : '100%'} pl={24} pr={!isMediumDevice ? 0 : 24}>
                  <LeftSectionWidget
                    state={state}
                    handleCheckboxChange={handleCheckboxChange}
                    handleGroupCheckboxChange={handleGroupCheckboxChange}
                    icon={icon}
                    setIcon={setIcon}
                    setHideIaLabsLogo={setHideIaLabsLogo}
                    setColorDisplay={setColorDisplay}
                    widgetState={widgetState}
                    setWidgetState={setWidgetState}
                    showWidgetInstruction={showWidgetInstruction}
                    setShowWidgetInstruction={setShowWidgetInstruction}
                  />
                </Flex>
              )}

              {(!isMediumDevice || isWidgetPreview) && (
                <WidgetPreview colorDisplay={colorDisplay} iconIds={checkedIds} hideIaLabsLogo={hideIaLabsLogo} />
              )}
            </Flex>
          </Flex>
          <Flex direction="column" w={!isMediumDevice ? '63%' : '100%'} pl={24} pr={!isMediumDevice ? 0 : 24}>
            <BottomActions
              widgetState={widgetState}
              isSubmitted={widget.error ? false : true}
              setShowWidgetInstruction={setShowWidgetInstruction}
              isWidgetPreview={isWidgetPreview}
              setIsWidgetPreview={setIsWidgetPreview}
            />
          </Flex>
        </Flex>
      </Grid>
    </Fragment>
  );
};

export default WidgetPage;
